import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../../components/LeftSocialMediaIconUI";
import { GrievanceRedressalLeftMenuList } from "../../utils/constants";
import { RenderNavItem } from "../../components/RenderNavItem";

const Pollution_Control_Board = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass">{t("About_Kolkata")} </h4>
            </div>
          </div>
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  ">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {GrievanceRedressalLeftMenuList.map((item, index) => (
                      <RenderNavItem
                        key={item.id || index}
                        item={item}
                        index={index}
                        t={t}
                      />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>

            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">{t("Procedure")}</h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <h5 className="fontSizeClass">
                      <strong>
                        {t(
                          " Address of Pollution Control Board for pollution from Generator set : "
                        )}
                      </strong>
                    </h5>
                  </div>

                  <div className="about-img3 mt-4 mr-4">
                    <p>
                      <strong>
                        Member Secretary <br></br>
                        West Bengal Pollution Control Board <br></br>
                        Paribesh Bhawan <br></br>
                        10-LA, Sector - III, Salt Lake City <br></br>
                        Kolkata - 700 098 <br></br>
                        Ph. : 1800-345-3390 (Toll Free) <br></br>
                        Email : wbpcbnet@wbpcb.gov.in
                      </strong>
                    </p>
                    <br></br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Pollution_Control_Board;
